export default "__VITE_ASSET__BvZsoShP__"